import { render, staticRenderFns } from "./psSet.vue?vue&type=template&id=2882e672&"
import script from "./psSet.vue?vue&type=script&lang=js&"
export * from "./psSet.vue?vue&type=script&lang=js&"
import style0 from "./psSet.vue?vue&type=style&index=0&id=2882e672&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports